import React from "react"
import ReactDOM from "react-dom/client"
import "./styles/globals.css"
import { App } from "@/app/App"
import { initializeSentry } from "@lib/sentry/sentry"

// Initialize Sentry BEFORE React renders
initializeSentry()

// Apply mjg-visio theme to document
document.documentElement.setAttribute("data-theme", "mjg-visio")

const root = document.getElementById("root")

if (!root) {
  throw new Error("React root element #root not found")
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
